import React, { useState, useMemo } from 'react';
import {
    Box, Card, TextField, Autocomplete, Tooltip, Select, MenuItem, Typography,
    IconButton, Button, Stack, InputAdornment, FormControl, InputLabel,
} from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, renderIconButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../Common/ShowComponent';
import { DeletePopup, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import RepeatIcon from '@mui/icons-material/Repeat';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';

const SarasTest = ({ Title, ...props }) => {
    const [state, setState] = useState({
        Testdata: [],
        isDeleteClicked: false,
        SelectedList: {},
        TestTransmitted: false,
        selectionModel: [],
        selectedRows: [],
        radSelectedRows: [],
        TestSuggestion: [],
        SelectedTest: null,
        SelectedType: '',
        disableType: true,
    });
    const [inputValue, setInputValue] = useState("");

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = () => {
        GetTestdata();
        getServiceTestData();
    }

    const GetTestdata = () => {
        const { patientId, appointmentId } = props
        try {
            RestAPIService.getAll(Serviceurls.SARAS_DOC_TEST_DATA + `?patient_id=${patientId}&appointment_id=${appointmentId}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({
                            Testdata: response.data.data || [],
                            TestTransmitted: response.data?.is_transmitted ? response.data?.is_transmitted : false
                        })
                    } else {
                        props.errorMessage(response?.data?.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            props.errorMessage(e?.message)
        }
    }

    const getServiceTestData = () => {
        const { clinicId } = props
        try {
            RestAPIService.getAll(Serviceurls.SARAS_DOC_TEST_SUGGESTION_GET + `?clinic_id=${clinicId}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({
                            TestSuggestion: response?.data?.data || [],
                        })
                    } else {
                        props.errorMessage(response?.data?.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            props.errorMessage(e?.message)
        }
    }

    const popupClose = () => {
        updateState({
            isDeleteClicked: false,
        })
    }

    const onDeleteHandler = (data) => {
        try {
            updateState({
                isDeleteClicked: true,
                SelectedList: data?.row,
            })
        } catch (error) {
            props.errorMessage(error?.message)
        }
    }

    const deleteTestdata = () => {
        try {
            RestAPIService.delete(Serviceurls.SARAS_DOC_TEST_DATA + `?appointment_id=${props?.appointmentId}&id=${state?.SelectedList?.id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        popupClose()
                        props.successMessage(response?.data?.message)
                        GetTestdata()
                    } else {
                        props.errorMessage(response?.data?.message)
                    }
                }).catch(error => {
                    props.errorMessage(error?.message)
                })
        } catch (e) {
            props.errorMessage(e?.message)
        }
    }

    const postTestTransmitData = () => {
        const { appointmentId, patientId } = props
        try {
            let data = {
                appointment_id: appointmentId,
                patient_id: patientId,
                line_item_ids: state?.selectedRows,
                radiology_line_items: state?.radSelectedRows,
            };
            updateState({ postLoading: true })
            RestAPIService.create(data, Serviceurls.TEST_TRANSMIT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response?.data?.message)
                        onClearHandler()
                        GetTestdata()
                        updateState({ postLoading: false })
                    }
                }).catch((error) => {
                    updateState({ postLoading: false })
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ postLoading: false })
            props.errorMessage(error.message)
        }
    }

    const postTestDatas = () => {
        const { appointmentId, patientId } = props
        try {
            let data = {
                "appointment_id": appointmentId,
                "patient_id": patientId,
                test_list: Array.isArray(state?.SelectedTest)
                    ? [...state.SelectedTest] : state?.SelectedTest ? [state.SelectedTest] : [],
            };
            updateState({ postLoading: true })
            RestAPIService.create(data, Serviceurls.SARAS_DOC_TEST_DATA)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response?.data?.message)
                        onClearHandler()
                        updateState({
                            postLoading: false, SelectedTest: null,
                            SelectedType: '',
                        })
                        setInputValue("");
                        GetTestdata()
                    }
                }).catch((error) => {
                    updateState({ postLoading: false })
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ postLoading: false })
            props.errorMessage(error.message)
        }
    }

    const printTestData = () => {
        const { appointmentId, patientId } = props
        try {
            RestAPIService.getAll(`${Serviceurls.SARAS_DOC_TEST_DATA}?appointment_id=${appointmentId}&patient_id=${patientId}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        props.errorMessage(error.response.data.message)
                    } else {
                        props.errorMessage(error.message)
                    }
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const handleTableCheckbox = (selectedIds) => {
        const selectedSet = new Set(selectedIds);
        const previousSelection = new Set(state.selectionModel);
        const updatedSelection = new Set(selectedIds);

        // Step 1: Identify package IDs for selection
        const packageIdsToSelect = new Set();
        state?.Testdata.forEach(row => {
            if (selectedSet.has(row.id) && row.package_id) {
                packageIdsToSelect.add(row.package_id);
            }
        });

        // Step 2: Add all rows belonging to selected package IDs
        state?.Testdata.forEach(row => {
            if (packageIdsToSelect.has(row.package_id)) {
                updatedSelection.add(row.id);
            }
        });

        // Step 3: Identify package IDs for deselection
        const deselectedIds = [...previousSelection].filter(id => !selectedSet.has(id));
        const packageIdsToDeselect = new Set();

        deselectedIds.forEach(id => {
            const deselectedRow = state?.Testdata.find(row => row.id === id);
            if (deselectedRow && deselectedRow.package_id) {
                packageIdsToDeselect.add(deselectedRow.package_id);
            }
        });

        // Step 4: Remove all rows belonging to deselected package IDs
        state?.Testdata.forEach(row => {
            if (packageIdsToDeselect.has(row.package_id)) {
                updatedSelection.delete(row.id);
            }
        });

        // Step 5: Categorize selected data into lab and radiology lists
        const { labSelectedList, radSelectedList } = state?.Testdata?.reduce(
            (acc, element) => {
                if (updatedSelection.has(element.id)) {
                    if (element.module_type === "LAB") {
                        acc.labSelectedList.push(element);
                    } else {
                        acc.radSelectedList.push(element);
                    }
                }
                return acc;
            },
            { labSelectedList: [], radSelectedList: [] }
        );

        // Step 6: Update state
        updateState({
            selectionModel: [...updatedSelection],
            radSelectedRows: radSelectedList,
            selectedRows: labSelectedList,
            isCheckClicked: updatedSelection.size > 0,
        });
    };


    const onClearHandler = () => {
        updateState({
            selectedRows: [],
            radSelectedRows: [],
            SelectedTest: null,
            SelectedType: '',
            disableType: true,
            isDeleteClicked: false,
        })
        setInputValue("");
    }

    const columns = [
        {
            field: "display_label", flex: 0.3, headerName: "Service Description",
            renderCell: (params) => {
                return (
                    <Box component={'div'}>
                        {params?.row?.service_name ? params?.row?.service_name?.length > 25 ?
                            <Tooltip placement='top' title={params?.row?.service_name} arrow>
                                <div>{params?.row?.service_name.slice(0, 23) + "..."}</div></Tooltip> :
                            (params?.row?.service_name || '-') : params?.row?.package_name ? params?.row?.package_name?.length > 25 ?
                                <Tooltip placement='top' title={params?.row?.package_name} arrow>
                                    <div>{params?.row?.package_name.slice(0, 23) + "..."}</div></Tooltip> :
                                (params?.row?.package_name || '-') : params?.row?.special_test_name?.length > 25 ?
                            <Tooltip placement='top' title={params?.row?.special_test_name} arrow>
                                <div>{params?.row?.special_test_name.slice(0, 23) + "..."}</div></Tooltip> :
                            (params?.row?.special_test_name || '-')}
                        {params?.row?.package_name ? <Typography fontSize={'.8vw'}>{params?.row?.package_name}</Typography> : null}
                    </Box>
                )
            }
        },
        {
            field: "type", flex: 0.25, headerName: "Module",
            renderCell: ({ row }) => (<Box component={'div'}>
                {row?.module_type ? row?.module_type : "-"}
            </Box>)
        },
        {
            field: "status", flex: 0.2, headerName: "Status", headerAlign: "center", align: 'center',
            renderCell: (params) => (<Box component={'div'}>
                {params?.row?.status ? params?.row?.status : params?.row?.is_transmitted ? 'Inprogress' : "Await to transmit"}
            </Box>)
        },
        {
            field: "action", flex: 0.15, headerName: "Action", headerAlign: "center", align: "center",
            renderCell: (params) => {
                const selectedIds = new Set(state?.selectionModel || []);
                const list = params?.row?.package_lines?.map((item, index) => `${index + 1}. ${item.service_name}, `)

                return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                    {params?.row?.package_lines?.length > 0 ? <Tooltip title={list} placement='top'><IconButton size="small" sx={{ width: '1vw', height: '1vw', marginRight: '1vw' }}><VisibilityIcon color='primary' /></IconButton></Tooltip> : null}
                    <CommonDeleteButton size={"1.2vw"}
                        disable={props?.isLocked || params?.row?.is_transmitted || selectedIds.has(params?.row?.id)}
                        onClick={() => onDeleteHandler(params)} />
                </Box>)
            }
        }
    ]

   const disableBtn = useMemo(() => {
        return !(state.SelectedTest) || props.isLocked;
    }, [state.SelectedTest, props.isLocked]);

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                    <Box display={"flex"} flexDirection={'row'} alignItems={"center"} columnGap={"1vw"}>
                        <Button
                            className='Common_Btn_Min_Width'
                            onClick={() => printTestData()}
                        >
                            <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
                        </Button>
                        <Tooltip title={"Transmit"} arrow placement='top'>
                            <Button
                                disabled={(state.Testdata?.every(item => item?.is_transmitted)) || props.isLocked || state.Testdata?.length === 0 || state.selectionModel?.length === 0}
                                onClick={() => postTestTransmitData()}
                                startIcon={<RepeatIcon />}
                                variant='outlined'
                                size='small'
                                sx={{ marginX: '0.5vw', textTransform: 'capitalize' }}
                            >Transmit</Button>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0.5vw' }}>
                    <Autocomplete
                        freeSolo
                        options={state?.TestSuggestion}
                        getOptionLabel={(option) => {
                            if (typeof option === "string") return option;
                            if (option?.service_name || option?.package_name || option?.name) {
                                return option.service_name || option.package_name || option.name;
                            }
                            return "";
                        }}
                        value={state?.SelectedTest}
                        size="small"
                        sx={{ width: "27vw", mr: "1vw" }}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                    textAlign: "left",
                                }}
                            >
                                <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }}>
                                    {option?.service_name || option?.package_name || option?.name || "-"}
                                </Typography>
                                <Typography
                                    fontSize=".8vw"
                                    fontWeight="bold"
                                    sx={{ width: "100%", textAlign: "left" }}
                                >
                                    <Box
                                        component="span"
                                        sx={{ color: "black", fontWeight: "bold", fontSize: ".8vw" }}
                                    >
                                        {option?.module_type === "LAB"
                                            ? "LABORATORY"
                                            : option?.module_type || "-"}
                                    </Box>{" "} - {" "}
                                    <Box
                                        component="span"
                                        sx={{
                                            color: option?.test_id
                                                ? "#FF4838"
                                                : option?.grp_id
                                                    ? "#29B6F6"
                                                    : option?.package_id
                                                        ? "#1E972A"
                                                        : option?.name
                                                            ? "#FA7E2F"
                                                            : option?.module_type === "RADIOLOGY"
                                                                ? "#1E972A"
                                                                : "inherit",
                                            fontSize: ".8vw",
                                        }}
                                    >
                                        {option?.test_type || ""}
                                    </Box>
                                </Typography>
                            </Box>
                        )}
                        onChange={(event, newValue) => {
                            const valueObj = typeof newValue === "string"
                                ? { id: null, name: newValue, module_type: 'SPECIAL TEST', SelectedType: 'SPECIAL TEST' }
                                : newValue;

                            updateState({
                                SelectedTest: valueObj,
                                SelectedType: valueObj?.module_type,
                            });

                            setInputValue(
                                typeof newValue === "string"
                                    ? newValue
                                    : newValue?.service_name || newValue?.package_name || newValue?.name || ""
                            );
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue, reason) => {
                            setInputValue(newInputValue);
                            if (reason === "input") {
                                updateState({
                                    SelectedTest: { id: null, name: newInputValue, module_type: 'SPECIAL TEST', SelectedType: 'SPECIAL TEST' },
                                });
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Search Laboratory & Radiology Test"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <>
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                            {params.InputProps.startAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    <FormControl disabled={props.isLocked || state.disableType} sx={{ width: '19vw', marginRight: "1vw" }} size='small'>
                        <InputLabel>Select</InputLabel>
                        <Select
                            label='select'
                            value={state.SelectedType}
                            disabled={props.isLocked || state.disableType}
                            onChange={(e) => {
                                updateState({ SelectedType: e.target.value })
                            }}
                        >
                            <MenuItem value={'LAB'}>Laboratory</MenuItem>
                            <MenuItem value={'RADIOLOGY'}>Radiology</MenuItem>
                            <MenuItem value={'SPECIAL TEST'}>Special</MenuItem>
                            {(state?.SelectedTest?.module_type && state?.SelectedTest?.module_type !== "LAB"  && state?.SelectedTest?.module_type !== "RADIOLOGY"  && state?.SelectedTest?.module_type !== "SPECIAL TEST")  && <MenuItem value={state?.SelectedTest?.module_type}>{state?.SelectedTest?.module_type}</MenuItem>}
                        </Select>
                    </FormControl>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        {renderIconButton('Add', ImagePaths[disableBtn ? 'DisabledAddIcon' : 'AddIcon'].default, postTestDatas, disableBtn, "2vw")}
                    </Box>
                </Box>
                <Box height={'20vh'} overflow={'auto'}>
                    <DataGrid
                        density='compact'
                        rows={state.Testdata}
                        columns={columns}
                        getRowId={(row) => row['id']}
                        checkboxSelection
                        selectionModel={state.selectionModel}
                        onSelectionModelChange={(selectedIds) => handleTableCheckbox(selectedIds)}
                        headerHeight={40}
                        hideFooter={true}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_DocNotes_nodata'>
                                    {"No Records To Be Shown"}
                                </Stack>
                            )
                        }}
                        disableSelectionOnClick
                        isRowSelectable={(params) => !(params?.row?.is_transmitted || params?.row?.module_type === 'SPECIAL TEST')}
                    />
                </Box>
                {state.isDeleteClicked && <DeletePopup
                    DeletTitle={`${"Are you sure you want to delete"}  ${Title} ?`}
                    deleteAlertPopupClose={popupClose.bind(this)}
                    removeData={deleteTestdata.bind(this)}
                />}
            </Card>
        </ShowComponents >
    )
}

export default SarasTest